<template>
    <b-table id="table-dependency" 
             class="custom-table-list"
             sort-icon-left 
             :items="options" 
             :fields="fields"
             :sort-by.sync="sortBy"
             :sort-desc.sync="sortDesc">
        
        <template v-slot:cell(Name)="data">
            <a :href="`${linkEdit}?id=${data.item.Id}&api-Version=${apiVersion}`"
                         class="custom-table-list-link"
                         target="_blank"> 
                {{ data.value }} 
            </a>
        </template>

        <template v-if="isActivities" 
                  v-slot:cell(SubTags)="data">

            <div v-for="(item, index) in data.item.SubTags" 
                 :key="index"
                 class="v-center"
                 :class="(index + 1) < data.item.SubTags.length ? 'mb-13' : ''">
                <b-img rounded
                       v-bind="{ blank: true, width: 15, height: 15, class: 'm1' }" 							   
                       :blank-color="item.Color"
                       class="mr-5px" />

                {{ item.Name }} 

            </div>
            
        </template> 

        <template v-else v-slot:cell(Tag.Text)="data">
            
            <b-img rounded
                   v-bind="{ blank: true, width: 15, height: 15, class: 'm1' }" 							   
                   blank-color="#00AF00"
                   class="mr-5px" />

                {{ data.value }} 
            
        </template>        

    </b-table>
</template>

<script>

import AllRoutes from '@/routes/all.routes'

export default {
    props:{
        options:{
            type: Array,
            default: null
        },
        isActivities: {
            type: Boolean,
            default: false
        },
        apiVersion: {
            type: String,
            default: ""
        }
    },
    computed: {
        linkEdit: function() {
            return this.isActivities 
                        ? AllRoutes.Admin.Activities.Edit
                        : AllRoutes.Admin.StandardBooks.Edit;
        }
    },
    data: function() {
        
        let key = this.isActivities
                        ? 'SubTags'
                        : 'Tag.Text';

        let label = this.isActivities
                        ? 'Хэштеги'
                        : 'Хэштег';

        let sortBy = this.isActivities
                        ? 'SubTags[0].Name'
                        : 'Tag.Text';

        return {
            sortBy: sortBy,
            sortDesc: true,
            fields: [
                {
                    key: 'Name',
                    label: "Название",
                    sortable: true,
                    tdAttr: value => {
                        return { width: "60%" };
                    }
                },
                {
                    key: key,
                    label: label,
                    sortable: true
                }

            ],
        }
    }
}
</script>

<style>
#table-dependency th {
    border-top: none;
}
</style>